import { Link } from "react-router-dom";

export const Logo = ({ testId, className = "" }) => (
  <Link to="/" data-testid={testId} aria-label="Water System Bros. home" className={`block font-head font-black uppercase leading-[0.88] tracking-[-0.01em] text-[19px] ${className}`}>
    <span className="block">Water</span>
    <span className="block">System</span>
    <span className="block">Bros.</span>
  </Link>
);
